import "common/assets/css/text-editor.css";
import { Box, Text } from "@chakra-ui/react";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import { useMemo } from "react";
import CustomToolbar from "./component/CustomToolBar";
import { textEditorInfo } from "common/data/textEditor";
import { globalStyles } from "common/theme/styles";

const TextEditor = ({ toolbarId = "toolbar", value, errorMsg, handleChange, handleBlur, borderColor, isDisabled = false, maxLength }) => {
    const colors = globalStyles.colors;

    const modules = useMemo(() => ({
        toolbar: {
            container: `#${toolbarId}`,
            handlers: {
                undo: function () {
                    this.quill.history.undo();
                },
                redo: function () {
                    this.quill.history.redo();
                },
            },
        },
        history: {
            delay: 2000,
            maxStack: 500,
            userOnly: true,
        },
    }), [toolbarId]);

    // Calculate character count (strip HTML tags)
    const getTextLength = (html) => {
        if (!html) return 0;
        const text = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
        return text.length;
    };

    const currentLength = getTextLength(value);
    const isOverLimit = maxLength && currentLength > maxLength;

    return (
        <Box p={'0px'} w="100%">
            <CustomToolbar toolbarId={toolbarId} />
            <ReactQuill
                readOnly={isDisabled}
                borderColor={borderColor}
                theme="snow"
                name={toolbarId}
                value={value && value}
                onChange={handleChange && handleChange}
                onBlur={handleBlur && handleBlur}
                modules={modules}
                formats={textEditorInfo.textEditorFormat}
            />
            {maxLength && (
                <Text 
                    fontSize="sm" 
                    color={isOverLimit ? colors.errorText : colors.placeholder} 
                    mt={1}
                    textAlign="right"
                >
                    {currentLength} / {maxLength} characters
                </Text>
            )}
            {errorMsg && errorMsg.length > 0 &&
                <Text color={colors.errorText} ></Text>
            }
        </Box>
    );
};

export default TextEditor;
